export enum PlaylistType {
  DEFAULT = "0",
  WEBINAR = "1",
}
